<template>
  <div class="hello">
    <el-row>
      <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
        <div class="tablePlu">
          <p style="margin-bottom: 10px">全部终端</p>
          <el-input
            @keyup.enter.native="getCarNew"
            size="small"
            v-model="searchValue"
            :placeholder="$t('common.searchTip')"
          ></el-input>
          <el-date-picker
            v-if="isShow"
            v-model="valueDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="changeTime"
            :range-separator="$t('common.to')"
            :start-placeholder="$t('common.starDate')"
            :end-placeholder="$t('common.endDate')"
          >
          </el-date-picker>
          <el-table
            v-loading="loading"
            stripe
            ref="multipleTable"
            :row-key="getRowKeys"
            @selection-change="leftChange"
            height="300"
            border
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              :reserve-selection="reserve"
              :selectable="checkSelectable"
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              :label="$t('common.id')"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="terminalId"
              :label="$t('common.terminalId')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="carId"
              :label="$t('common.carId')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="typeName"
              label="终端型号"
            ></el-table-column>
          </el-table>
        </div>
        <iPagination
          ref="page"
          :isize="small"
          @PageFun="changeSize"
        ></iPagination>
        <el-button @click="pitchUp" size="small" type="primary">{{$t('common.btn.confirm')}}</el-button>
      </el-col>
      <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
        <div class="tablePlu">
          <p style="margin-bottom: 10px">已选终端</p>
          <el-input
            @keyup.enter.native="getCarSearch"
            style="width: 50% !important; margin-bottom: 10px"
            size="small"
            v-model="input"
            :placeholder="$t('common.searchTip')"
          ></el-input>
          <el-table
            stripe
            @selection-change="RightChange"
            height="300"
            border
            :data="checkedTable"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              :label="$t('common.id')"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="terminalId"
              :label="$t('common.terminalId')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="carId"
              :label="$t('common.carId')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="typeName"
              label="终端型号"
            ></el-table-column>
          </el-table>
        </div>
        <el-button
          style="margin-top: 10px"
          @click="deleteList"
          size="small"
          type="danger"
          >{{$t('common.btn.delete')}}</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
import iPagination from "./pagination.vue";
import moment from "moment";
export default {
  components: {
    iPagination,
  },
  data() {
    return {
      dialogVisible: false,
      searchValue: "",
      input: "",
      reserve: true,
      loading: false,
      tableData: [],
      checkedTable: [],
      selected: [],
      rightSelect: [],
      currentPage1: 1,
      pageNum: 1,
      small: true,
      pageSize: 10,
      getRowKeys(row) {
        return row.terminalId;
      },
      valueDate: [],
    };
  },
  props: ["isShow", 'paramsData', 'id'],
  computed: {
    paramsValue() {
      return {paramsData: this.paramsData,id: this.id}
    }
  },
  watch: {
    'paramsValue': {
      deep: true,
      immediate: true,
      handler: function(val) {
        this.getCar(val)
      }
    }
  },
  created() {
    this.getDate()
  },
  mounted() {
  },
  methods: {
    getDate() {
      const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      const startTime = moment(endTime)
        .subtract("2", "hour")
        .format("YYYY-MM-DD HH:mm:ss");
      this.valueDate = [startTime, endTime];
      this.$emit("getDate", this.valueDate);
    },
    getCarSearch() {
       var arr = this.checkedTable.filter((item) => {
        if(item.terminalId == this.input){
          return item
        }     
      });
      this.checkedTable = arr
    },
    getCarNew() {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getCar();
    },
    getCar(val) {
      this.loading = true;
      let orgId = ''
      if(val && val.id){
        orgId = val.id
      }else{
        orgId = sessionStorage.getItem('roleData')
      }
      let typeId = ''
      if(val && val.paramsData) {
        typeId = val.paramsData
      }
      let param = {
        orgId: orgId,
        terminalId: this.searchValue,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        typeId: typeId,
      };
      this.$store.dispatch("TerminalFile/GET_SELECTALLTERMINAL", param).then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.list;
            this.$refs.page.CommandTotal = res.data.data.total;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    changeSize(item) {
      console.log(item)
      this.pageNum = item.pageNum;
      this.pageSize = item.pageSize;
      this.getCar(this.paramsValue);
    },
    deleteList() {
      this.rightSelect.map((item, t) => {
        this.checkedTable.map((items, index) => {
          if (items.terminalId == item.terminalId) {
            this.checkedTable.splice(index, 1);
            this.$refs.multipleTable.toggleRowSelection(item, false);
          }
        });
      });
      this.$emit("postParam", this.checkedTable);
    },
    RightChange(selected) {
      this.rightSelect = selected;
    },
    checkSelectable(row) {
      let status;
      let length = this.checkedTable.length;
      if (length > 0) {
        for (let i = 0; i < length; i++) {
          if (this.checkedTable[i].terminalId == row.terminalId) {
            status = false;
            break;
          } else {
            status = true;
          }
        }
      } else {
        status = true;
      }
      return status;
    },
    pitchUp() {
      this.checkedTable = this.selected;
      this.$emit("postParam", this.checkedTable);
    },
    changeTime() {
      this.$emit("changeTime", this.valueDate);
    },
    leftChange(selected) {
      this.selected = selected;
    },
  },
};
</script>

<style lang='less' scoped>
@import "../assets/styles/command.less";
.el-table__body,
.el-table__footer,
.el-table__header {
  border-collapse: collapse;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #f2f6fc !important;
  border-color: #dcdfe6 !important;
}
</style>
